// Connection Arcade — local storage helpers (v1)
// Phase 1/2 scope: store solo Spark history locally. No matching logic.

const KEY = 'unitylove.arcade.spark.history.v1';

export function loadSparkHistory() {
  try {
    const raw = window?.localStorage?.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveSparkHistory(next) {
  try {
    window?.localStorage?.setItem(KEY, JSON.stringify(next));
  } catch {
    // ignore
  }
}

export function addSparkHistoryItem(item) {
  const prev = loadSparkHistory();
  const next = [item, ...prev].slice(0, 50); // cap history to keep it light
  saveSparkHistory(next);
  return next;
}
